module.exports = __webpack_public_path__ + "static/media/ProfPic.f256ce82.png";